import React, { Component } from "react";
import hand from "../../../assets/images/pointing-down-hand.svg";
import finger from "../../../assets/images/pointing-down-finger.svg";
import "../../../styles/pages/home/HomeHeaderFinger.css";
import $ from "jquery";

// The Component
export default class HomeHeaderFinger extends Component {
  componentDidMount() {
    $(window).on("scroll", this.onScroll.bind(this));
  }
  onScroll() {
    var scrollY = $(window).scrollTop();
    var finger = $(".HomeHeaderFinger .finger");
    var newFingerTranslateY = -75 + scrollY * 0.1;
    var maxFingerY = window.innerWidth <= 850 ? -32 : -25;
    if (newFingerTranslateY <= maxFingerY) {
      finger.css("transform", `translateY(${newFingerTranslateY}%)`);
    } else {
      finger.css("transform", `translateY(${maxFingerY}%)`);
    }
  }
  render() {
    return (
      <div className="HomeHeaderFinger">
        <img className="hand" src={hand} alt="A hand." />
        <div className="finger-container">
          <img className="finger" src={finger} alt="The finger of the hand." />
        </div>
      </div>
    );
  }
}
